import api from '@/fetch/api'
import { Dialog, Toast } from 'vant'

// 保存成功后自动提交备案审核（驾驶员/押运员/车头/车挂）
export default {
  methods: {
    /**
     * 备案信息保存成功后自动提交审核
     * @param {string} type - 'driver' | 'escort' | 'chetou' | 'chegua'
     * @param {string|number} id - 备案记录 id
     * @param {string} listRoute - 提交完成后跳转的列表路由 name
     */
    autoSubmitBeian(type, id, listRoute) {
      var that = this
      var submitApi, label
      switch (type) {
        case 'driver':
          submitApi = api.submitBeianJsy
          label = '驾驶员'
          break
        case 'escort':
          submitApi = api.submitBeianYsy
          label = '押运员'
          break
        case 'chetou':
          submitApi = api.submitBeianChetou
          label = '车头'
          break
        case 'chegua':
          submitApi = api.submitBeianChegua
          label = '车挂'
          break
        default:
          submitApi = api.submitBeianJsy
          label = '信息'
      }

      var formData = new FormData()
      formData.append('id', id)

      submitApi(formData)
        .then(function (res) {
          var resData = JSON.parse(res)
          var success = resData.respCode == '0' || resData.respCode === 0
          var msg = success
            ? label + '信息保存并提交审核成功'
            : '信息保存成功，但审核提交失败：' + (resData.message || '未知错误')

          Dialog.alert({ message: msg }).then(() => {
            that.$router.push({ name: listRoute })
          })
        })
        .catch(function (err) {
          console.error('[' + label + '] 自动提交审核失败', err)
          Dialog.alert({
            message: '信息保存成功，但审核提交失败，请到列表页手动提交',
          }).then(() => {
            that.$router.push({ name: listRoute })
          })
        })
    },
  },
}
